/*
 * Routes where a transparent reload cannot discard in-progress work. These are
 * stateless pages backed entirely by server data — landing/list pages and the
 * read-only insights reports — deliberately never the multi-step study
 * creation, review, processing or context-pack flows, which hold unsaved
 * client state.
 */
const SAFE_RELOAD_ROUTES: RegExp[] = [
  /^\/$/, // home
  /^\/projects$/, // projects list
  /^\/projects\/[^/]+$/, // project details
  /^\/studies$/, // studies list
  /^\/contexts$/, // context packs list
  /^\/projects\/[^/]+\/studies\/[^/]+\/(asset|scene|video)\/reports\//, // insights reports (report + in-depth views)
];

/**
 * isSafeReloadPath function
 * Determines whether the given route is a safe place to transparently reload the
 * app, so an auto-refresh can never interrupt or discard in-progress work.
 *
 * @param path - The current location pathname
 * @returns true if it is safe to hard-reload on this route
 */
export const isSafeReloadPath = (path: string): boolean => {
  return SAFE_RELOAD_ROUTES.some((pattern) => pattern.test(path));
};
